import bannerEdit from './edit.vue'
import bannerList from './list.vue'

let a = Object.assign({ bannerEdit, bannerList})
export default a;